module.exports = __webpack_public_path__ + "img/4.475fa22e.jpeg";